import dynamic from "next/dynamic";
import { StoryblokStoryComponent } from "../lib/storyblok/types/StoryblokComponent";
import { ViewModel } from "../lib/viewModel/createViewModel";

// Regular imports for non-search pages
import SimpleContentPage from "./PageTemplates/SimpleContentPage";
import EventPage from "./PageTemplates/EventPage";
import InvestorEventPage from "./PageTemplates/InvestorEventPage";
import ArticlePage from "./PageTemplates/ArticlePage";
import ResourcePage from "./PageTemplates/ResourcePage";
import StartPage from "./PageTemplates/StartPage";
import ImagevaultGalleryPage from "./PageTemplates/ImagevaultGalleryPage";
import PublicationPage from "./PageTemplates/PublicationPage";
import DisclaimerContentPage from "./PageTemplates/DisclaimerContentPage";

// Dynamic imports for search/finder pages to prevent Algolia from loading on every page
const MainSearchPage = dynamic(() => import("./PageTemplates/MainSearchPage"), { ssr: true }) as StoryblokStoryComponent;
const ProductFinderPage = dynamic(() => import("./PageTemplates/ProductFinderPage"), { ssr: true }) as StoryblokStoryComponent;
const ResourceFinderPage = dynamic(() => import("./PageTemplates/ResourceFinderPage"), { ssr: true }) as StoryblokStoryComponent;
const PressreleaseFinderPage = dynamic(() => import("./PageTemplates/PressreleaseFinderPage"), { ssr: true }) as StoryblokStoryComponent;
const EventFinderPage = dynamic(() => import("./PageTemplates/EventFinderPage"), { ssr: true }) as StoryblokStoryComponent;
const ArticleFinderPageV2 = dynamic(() => import("./PageTemplates/ArticleFinderPageV2"), { ssr: true }) as StoryblokStoryComponent;
const InvestorSearchPage = dynamic(() => import("./PageTemplates/InvestorSearchPage"), { ssr: true }) as StoryblokStoryComponent;

const NotCreated: StoryblokStoryComponent = ({ story }) => (
  <pre>
    The story component <strong>{story.content.component}</strong> has not been
    created yet.
  </pre>
);

const components: { [index: string]: StoryblokStoryComponent } = {
  productPage: SimpleContentPage,
  simpleContentPage: SimpleContentPage,
  landingPage: SimpleContentPage,
  solutionsPage: SimpleContentPage,
  mainEventPage: EventPage,
  eventPage: InvestorEventPage,
  articlePage: ArticlePage,
  searchPage: MainSearchPage,
  investorSearchPage: InvestorSearchPage,
  resourcePage: ResourcePage,
  productFinderPage: ProductFinderPage,
  resourceFinderPage: ResourceFinderPage,
  pressreleaseFinderPage: PressreleaseFinderPage,
  eventFinderPage: EventFinderPage,
  articleFinderPageV2: ArticleFinderPageV2,
  startPage: StartPage,
  imagevaultGalleryPage: ImagevaultGalleryPage,
  publicationPage: PublicationPage,
  disclaimerContentPage: DisclaimerContentPage,
};

type Props = { viewModel: ViewModel };

export const DynamicStory = ({ viewModel }: Props) => {
  const Component = components[viewModel.story.content.component];

  if (Component === undefined) return <NotCreated {...viewModel} />;

  return <Component {...viewModel} />;
};
